export const VIEW_OPTIONS_TILES = 'tiles';
export const VIEW_OPTIONS_COLUMNS = 'columns';
